__turbopack_context__.v({
  "card": "Midbannersection-module-scss-module__csRerW__card",
  "cardBody": "Midbannersection-module-scss-module__csRerW__cardBody",
  "cardButton": "Midbannersection-module-scss-module__csRerW__cardButton",
  "cardDescription": "Midbannersection-module-scss-module__csRerW__cardDescription",
  "cardGrid": "Midbannersection-module-scss-module__csRerW__cardGrid",
  "cardImage": "Midbannersection-module-scss-module__csRerW__cardImage",
  "cardTitle": "Midbannersection-module-scss-module__csRerW__cardTitle",
  "divider": "Midbannersection-module-scss-module__csRerW__divider",
  "heading": "Midbannersection-module-scss-module__csRerW__heading",
  "mobileCarousel": "Midbannersection-module-scss-module__csRerW__mobileCarousel",
  "section": "Midbannersection-module-scss-module__csRerW__section",
});
